module.exports = __webpack_public_path__ + "images/130_640.jpg";